import React, { useEffect, useState } from "react";
import { PutAwayModalWrapper } from "./putAwayModal.style";
import Modal from "antd/lib/modal/Modal";
import { Button, Divider, InputNumber, Switch, Tag, message } from "antd";
import { IoRefresh } from "react-icons/io5";
import RackSearch from "../../../TOBinTransfer/TOBinPicker/TOBPMain/RackSearch/RackSearch";
import { suggestLocationForPutAway } from "../../service/putAwayServices";
import { SOMETHING_WENT_WRONG, warehouseId } from "../../../../constants";
import { handleError } from "../../../../redux/makeApiCall";
import { Base64func } from "../../../../components/Base64Func/Base64func";
const PutAwayModal = ({ onSubmit, record, access_token, onCancel }) => {
  const [disableSuggestion, setDisableSuggestion] = useState(false);
  const [gettingSuggestion, setGettingSuggestion] = useState(false);
  const [rackNumber, setRackNumber] = useState(null);
  const [suggestedRack, setSuggestedRack] = useState(null);
  const [selectedQty, setSelectedQty] = useState();
  const [isBinFull, setIsBinFull] = useState(false);
  const [clearRackInput, setClearRackInput] = useState(false);

  const submitHandler = () => {
    const params = {
      ...record,
      isBinFull,
      binNumber: rackNumber,
      availableQty: selectedQty,
    };
    onSubmit(params);
  };

  const onChangeHandler = (type, payload) => {
    switch (type) {
      case "isBinFull":
        setIsBinFull(payload);
        break;
      case "selectQty":
        setSelectedQty(payload);
        break;
      case "useSuggested":
        setRackNumber(payload);
        break;
      case "useRackSearch":
        setRackNumber(payload?.value);
        break;
      case "useScanner":
        setRackNumber(payload);
        break;

      default:
        break;
    }
  };

  const getSuggestedRack = async () => {
    try {
      setGettingSuggestion(true);
      const params = {
        productCode: record.productCode,
        batchNumber: encodeURIComponent(record.batchNumber),
        warehouseId,
        access_token: access_token,
      };
      const response = await suggestLocationForPutAway(params);
      if (response.data.statusCode === 200) {
        if (response.data?.responseData?.suggestedBin) {
          setSuggestedRack(response.data?.responseData?.suggestedBin);
          disableSuggestion && setDisableSuggestion(false);
          setGettingSuggestion(false);
        } else {
          setDisableSuggestion(true);
          throw new Error(response.data.message || SOMETHING_WENT_WRONG);
        }
      } else if (response.data.statusCode === 204) {
        throw new Error(response.data.message || SOMETHING_WENT_WRONG);
      }
    } catch (error) {
      const err = handleError(error);
      message.error(err || SOMETHING_WENT_WRONG);
      setGettingSuggestion(false);
      setDisableSuggestion(true);
    }
  };
  const refreshSuggestedRack = () => {
    message.info("Fetching rack suggestion");
    getSuggestedRack();
  };
  useEffect(() => {
    getSuggestedRack();
  }, []);

  return (
    <Modal centered open onCancel={onCancel} footer={false}>
      <React.Fragment>
        <PutAwayModalWrapper submitDisabled={!rackNumber}>
          <p className="title">{record.productName}</p>
          <div className="header">
            <p className="subtitle">{record.productCode} </p>
            <p className="batch">
              Batch# <span>{record.batchNumber}</span>{" "}
            </p>
          </div>
          <div className="selectRack">
            <p className="label">Select Rack</p>
            <div className="suggested">
              <Button
                loading={gettingSuggestion}
                onClick={() => {
                  onChangeHandler("useSuggested", suggestedRack);
                  setClearRackInput(true);
                }}
                className="selectBinBtn"
                size="large"
                disabled={disableSuggestion}
              >
                Use Suggested : {suggestedRack}
              </Button>
              <button onClick={refreshSuggestedRack} className="refreshBtn">
                <IoRefresh size={25} color="#2f65cb" />
              </button>
            </div>
            <Divider style={{ margin: "10px 0" }} plain>
              Or
            </Divider>
            <div className="selectRackWrapper">
              <div className="rackSearch">
                <RackSearch
                  updateSelectedBin={(value) => {
                    onChangeHandler("useRackSearch", value);
                    setClearRackInput(false);
                  }}
                  isPutAway={true}
                  redirect="to-putaway-item"
                  onScanHandler={onChangeHandler}
                  clearState={clearRackInput}
                />
              </div>
            </div>
          </div>
          <div className="selectedRack">
            <p className="label">Selected Rack :</p>
            <p className="value">
              {rackNumber ? rackNumber : <Tag color="magenta">Select Rack</Tag>}
            </p>
          </div>
          <div>
            <label className="selectQtyLabel">Select QTY</label>
            <InputNumber
              style={{
                width: "100%",
              }}
              value={selectedQty}
              placeholder="Select Quantity"
              min={0}
              max={record.pendingQuantity}
              onChange={(e) => {
                onChangeHandler("selectQty", e);
              }}
            />
          </div>
          <div className="isBinEmpty">
            <p className="label">Bin Is Full</p>
            <Switch
              checked={isBinFull}
              onChange={(value) => {
                onChangeHandler("isBinFull", value);
              }}
            />
          </div>
          <div className="subtmitBtnWrapper">
            <button
              disabled={!rackNumber}
              onClick={submitHandler}
              className="submit"
            >
              Submit
            </button>
          </div>
        </PutAwayModalWrapper>
      </React.Fragment>
    </Modal>
  );
};

export default PutAwayModal;
